// extracted by mini-css-extract-plugin
module.exports = {"root":"CompleteLink_root__1uZOR","rootSuccess":"CompleteLink_rootSuccess__FzYmo","rootFailure":"CompleteLink_rootFailure__2iinf","isDisabled":"CompleteLink_isDisabled__3_tzV"};